import { LogLevel } from 'src/app/core/logging/log-level';

export abstract class Logger {

    private readonly logLevel: LogLevel;

    public constructor(level: LogLevel) {
        this.logLevel = level;
    }

    /**
     * Logs a debug message.
     */
    public debug(message: unknown, ...additional: unknown[]): void {
        this.processLog(LogLevel.DEBUG, message, additional);
    }

    /**
     * Logs an info message.
     */
    public info(message: unknown, ...additional: unknown[]): void {
        this.processLog(LogLevel.INFO, message, additional);
    }

    /**
     * Logs a warning message.
     */
    public warn(message: unknown, ...additional: unknown[]): void {
        this.processLog(LogLevel.WARN, message, additional);
    }

    /**
     * Logs an error message.
     */
    public error(message: unknown, ...additional: unknown[]): void {
        this.processLog(LogLevel.ERROR, message, additional);
    }

    /**
     * Logs a message.
     * @param level The log level.
     * @param message The log message.
     * @param additional Additional logging entries.
     * @protected
     */
    protected abstract log(level: LogLevel, message: unknown, additional?: unknown[]): void;

    /**
     * Processes an incoming log message. Will only forward log messages with a high enough log level.
     * @param logLevel The log level.
     * @param message The log message.
     * @param additional  Additional logging entries.
     * @private
     */
    private processLog(logLevel: LogLevel, message: unknown, additional: unknown[] = []): void {
        if (logLevel >= this.logLevel) {
            this.log(logLevel, message, additional);
        }
    }
}
